import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'pos/'

const initialState = {
    MENU: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getItemsForPOS = createAsyncThunk('pos/gifpos', async (procOrder, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getItemsForPOS', procOrder)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const itemsInformationSlice = createSlice({
    name: 'pos',
    initialState,
    reducers: {
        reset: (state) => {
            state.MENU = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getItemsForPOS.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getItemsForPOS.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.MENU = action.payload
            })
            .addCase(getItemsForPOS.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = itemsInformationSlice.actions

export default itemsInformationSlice.reducer